import React from "react";
import {
  VictoryChart,
  VictoryLine,
  VictoryAxis,
  VictoryTooltip,
  VictoryVoronoiContainer,
  VictoryScatter,
  VictoryLegend,
} from "victory";

const DualLineChart = ({
  chartData,
  xlabel,
  yLabel1,
  yLabel2,
  y_low,
  y_high,
}) => {
  const y1Values = chartData && Array.isArray(chartData)
    ? chartData
        .map((d) => d.y1)
        .filter((v) => v !== null && v !== undefined)
    : [];
  const y2Values = chartData && Array.isArray(chartData)
    ? chartData
        .map((d) => d.y2)
        .filter((v) => v !== null && v !== undefined)
    : [];
  const allY = [...y1Values, ...y2Values];
  if (allY.length > 0) {
    y_low = Math.round(Math.min(...allY) - 10, 1);
    y_high = Math.round(Math.max(...allY) + 10, 1);
  }
  const interval = Math.ceil((y_high - y_low) / 5);
  const yTicks = Array.from({ length: 6 }, (_, i) => y_low + i * interval);

  return (
    <VictoryChart
      domainPadding={{ x: 20, y: 20 }}
      padding={{ bottom: 40, top: 40, left: 70, right: 20 }}
      containerComponent={<VictoryVoronoiContainer />}
      domain={{ y: [y_low, y_high] }}
    >
      <VictoryLegend
        x={125}
        y={10}
        orientation="horizontal"
        gutter={20}
        style={{
          labels: { fill: "#104a5c", fontSize: 20 },
        }}
        data={[
          { name: yLabel1, symbol: { fill: "#8884d8", type: "circle" } },
          { name: yLabel2, symbol: { fill: "#82ca9d", type: "triangleUp" } },
        ]}
      />
      <VictoryAxis
        tickValues={chartData && Array.isArray(chartData) ? Array.from({ length: chartData.length }, (_, i) => i + 1) : []}
        tickFormat={() => ""}
        // tickFormat={chartData && Array.isArray(chartData) ? chartData.map((d) => d.x) : []}
        label={xlabel}
        style={{
          axisLabel: { padding: 30, fill: "#104a5c", fontSize: 20 },
          tickLabels: { fill: "black", padding: 10 },
          ticks: { stroke: "black", size: 3 },
        }}
      />
      <VictoryAxis
        dependentAxis
        label="Value"
        tickValues={yTicks}
        style={{
          axisLabel: { fill: "#104a5c", padding: 40, fontSize: 20 },
          tickLabels: { fontSize: 10 },
          ticks: { stroke: "black", size: 3 },
        }}
      />
      <VictoryLine
        data={chartData && Array.isArray(chartData) ? chartData : []}
        x="x"
        y="y1"
        style={{ data: { stroke: "#8884d8", strokeWidth: 2 } }}
        interpolation="natural"
      />
      <VictoryLine
        data={chartData && Array.isArray(chartData) ? chartData : []}
        x="x"
        y="y2"
        style={{
          data: { stroke: "#82ca9d", strokeWidth: 2, strokeDasharray: "5,5" },
        }}
        interpolation="natural"
      />
    </VictoryChart>
  );
};

export default DualLineChart;